import React, { useEffect, useState } from 'react'
import DealerModel from './models/DealerModel';


function ViewDealer(props) {
  const [dealerData, setDealerData] = useState(new DealerModel());

  useEffect(() => {
    setDealerData(props.DealerData);
  }, [props.DealerData])
  return (
    <>
      <div className="row">
        <div className="col-lg-8">
          <div className="mb-3 add-product">
            <label className="form-label">Dealer Name</label>
            <input type="text" className="form-control" value={dealerData.DealerName ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="mb-3 add-product">
            <label className="form-label">Mobile</label>
            <input type="text" className="form-control" value={dealerData.MobileNumber ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Email</label>
            <input type="text" className="form-control" value={dealerData.EmailId ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Address 1</label>
            <input type="text" className="form-control" value={dealerData.AddressLine1 ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Address 2</label>
            <input type="text" className="form-control" value={dealerData.AddressLine2 ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Address 3</label>
            <input type="text" className="form-control" value={dealerData.AddressLine3 ?? ""} disabled />
          </div>
        </div>


        <div className="col-lg-3">
          <div className="mb-3 add-product">
            <label className="form-label">City</label>
            <input type="text" className="form-control" value={dealerData.City ?? ""} disabled />
          </div>
        </div>

        <div className="col-lg-3">
          <div className="mb-3 add-product">
            <label className="form-label">State</label>
            <input type="text" className="form-control" value={dealerData.State ?? ""} disabled />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="mb-3 add-product">
            <label className="form-label">Country</label>
            <input type="text" className="form-control" value={dealerData.Country ?? ""} disabled />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="mb-3 add-product">
            <label className="form-label">Pin</label>
            <input type="text" className="form-control" value={dealerData.PinNumber ?? ""} disabled />
          </div>
        </div>

      </div>
    </>
  )
}

export default ViewDealer